import OrgCompPlanService from "@/services/bytepro/orgCompPlan.service";

export const orgCompPlanApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    get({ commit }, organizationId) {
      return OrgCompPlanService.get(organizationId).then(
        (resp) => {
          commit("dummyConsole", "OrgCompPlanService.get - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "OrgCompPlanService.get - error");
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
